import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ApiCacheProvider } from './context/api-context';
import { UserProvider } from './context/app-context';
import { AyeProvider } from './context/usePortal';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Register service worker for Firebase messaging
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Firebase messaging service worker registered:', registration);
      })
      .catch((error) => {
        console.error('Firebase messaging service worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* <Suspense
      fallback={
        <div
          style={{ minHeight: `calc(100vh - 64px)` }}
          className="flex items-center justify-center"
        >
          <Loader />
        </div>
      }
    > */}
    <ApiCacheProvider>
      <AyeProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </AyeProvider>
    </ApiCacheProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
